import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetUnitsListContentSlice = createSlice({
    name: "getUnitsListContent",
    initialState,
    reducers: {
        getUnitsListContentRequest(state) {
            state.loading = true;
        },
        getUnitsListContentRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getUnitsListContentRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        clearUnitsListContentResponse(state) {
            state.response = undefined;
            state.error = undefined;
            state.loading = false;
        }
    },
});

export const {
    getUnitsListContentRequest,
    getUnitsListContentRequestSuccess,
    getUnitsListContentRequestError,
    clearUnitsListContentResponse
} = GetUnitsListContentSlice.actions;

export default GetUnitsListContentSlice.reducer;
